<template>
  <div class="jumbotron">
    <loading :active.sync="loading"></loading>
    <h4>Photos</h4>
    <div v-if="getImages.length !== 0" class="row">
      <div class="col">
        <div class="card-columns">
          <image-card v-for="image in getImageUrls" :key="image" v-bind:image-url="image"></image-card>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="no-margin-bottom">Total file size must be less than 6MB</p>
        <div class="custom-file">
          <input @change="previewImage"
                 type="file"
                 ref="image"
                 class="custom-file-input"
                 id="customFile"
                 multiple accept="image/png, image/jpeg">
          <label class="custom-file-label" for="customFile">Choose file</label>
        </div>
        <img v-for="(image, index) in imageData"
             class="preview-image"
             v-bind:key="index"
             v-bind:src="image"
             v-on:click="removeImage(index)"
             alt="not working"
             height="100px"/>
        <b-alert variant="warning"
                 dismissible
                 :show="showImagesTooBig"
                 @dismissed="showImagesTooBig=false">
          The Images you have uploaded are too large. Try uploading fewer or smaller images.
        </b-alert>
      </div>
    </div>
    <div class='row homapt-padding-bottom'>
      <div class='col-lg-6 offset-lg-3'>
        <button v-on:click="saveData"
                v-if="imageData.length > 0"
                class='btn btn-primary'>Upload</button>
        <div v-else>
          <button v-if="complete" v-on:click="save" class='btn btn-primary'>Save</button>
          <button v-else v-on:click="save" class="btn btn-primary">Save & Continue</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
        <b-alert variant="warning"
             dismissible
             :show="imageTooSmall"
             @dismissed="imageTooSmall=false">
          The image you uploaded is too small.
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import imageCard from './ImageCard.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import router from '../../../../router/index.js'

export default {
  created () {
    this.complete = this.profileIsComplete.profileComplete
  },
  components: {
    imageCard,
    Loading
  },
  data () {
    return {
      loading: false,
      imageData: [],
      showImagesTooBig: false,
      complete: false,
      showDismissibleAlert: false,
      imageTooSmall: false
    }
  },
  computed: {
    ...mapGetters([
      'getCognitoId'
    ]),
    ...mapGetters('business', [
      'profileIsComplete'
    ]),
    ...mapGetters('user', [
      'getUserType'
    ]),
    getImages () {
      if (this.getUserType === 'business') return this.$store.getters['business/getImages']
      if (this.getUserType === 'user') return this.$store.getters['user/getImages']
    },
    getImageUrls () {
      if (this.getUserType === 'business') return this.$store.getters['business/getImageUrls']
      if (this.getUserType === 'user') return this.$store.getters['user/getImageUrls']
    }
  },
  methods: {
    ...mapActions('business', [
      'getUserAttributes'
    ]),
    previewImage: function (event) {
      var input = event.target
      var that = this
      for (var i = 0; i < input.files.length; i++) {
        if (input.files && input.files[i]) {
          var reader = new FileReader()
          reader.onload = function (e) {
            if (!that.imageData.includes(e.target.result)) {
              var img = new Image()
              img.onload = function () {
                if (this.width > 150 && this.height > 150) {
                  that.imageData.push(e.target.result)
                } else {
                  that.imageTooSmall = true
                }
              }
            }
            img.src = e.target.result
          }
          reader.readAsDataURL(input.files[i])
        }
      }

      var fileInput = document.getElementById('customFile')
      fileInput.value = null
    },
    removeImage (index) {
      this.imageData.splice(index, 1)
    },
    async sendImage (image) {
      var client = this.$store.getters.getImageApigClientFactory
      var params = {}
      var pathTemplate = '/uploadimage'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        images: [image],
        userType: this.getUserType
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      } catch (error) {
        console.log(error)
      }
    },
    async saveData () {
      this.loading = true
      try {
        await Promise.all(this.imageData.map(image => this.sendImage(image)))
        await this.getUserAttributes()
        this.imageData = []
        this.showImagesTooBig = false
        this.showDismissibleAlert = true
      } catch (error) {
        if ((error.message === 'Request Too Long') || (error.message === 'Network Error')) {
          this.showImagesTooBig = true
        }
        console.log(error)
      }
      this.loading = false
    },
    async save () {
      this.saveData()
      if (!this.complete && (this.getUserType === 'business')) {
        router.replace('/profile/business/details/about')
      }
    }
  },
  mounted () {
    this.$global.gaEvent('userPhotos', 'navigation')
  }
}
</script>

<style scoped>
input {
  width: 100%;
}

.preview-image {
  margin: 1rem;
}

.form-row-padding {
  padding-bottom: 2rem;
}

.homapt-padding-bottom {
  padding-bottom: 2rem;
}

.top-row-padding {
  padding-bottom: 1rem;
}

.jumbotron {
  background-color:  #f1f1f1  !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.btn {
  margin-top: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/shared/pictures/Pictures.vue